import { render, staticRenderFns } from "./BarBillsChart.vue?vue&type=template&id=1f67cb1d"
import script from "./BarBillsChart.vue?vue&type=script&lang=js"
export * from "./BarBillsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports